const getSettings = async () => {
  return fetch( '/app.settings.json' ).then( response => response.json() );
};

export const settings = await getSettings();
